import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { styled } from '@mui/material/styles';
import CheckboxIcon from 'assets/icons/checkbox.svg';
import CheckboxDisabledIcon from 'assets/icons/checkboxDisabled.svg';
import classNames from 'classnames';
import { array, object, string } from 'prop-types';
import React from 'react';
import svgToStaticMarkup from 'utils/svgToStaticMarkup';

const checkBoxIconUri = svgToStaticMarkup(<CheckboxIcon />);
const checkBoxDisabledIconUri = svgToStaticMarkup(<CheckboxDisabledIcon />);

const CheckboxIconSpan = styled('span')(({ theme }) => ({
  width: '1em',
  height: '1em',
  padding: '2px',
  '&:before': {
    content: '""',
    display: 'block',
    width: '100%',
    height: '100%',
    borderRadius: '3px',
    backgroundColor: theme.palette.white,
    border: `1px solid ${theme.palette.secondary.light}`,
  },
  'input:hover ~ &:before': {
    borderColor: theme.palette.primary.light2,
  },
  'input:disabled ~ &:before': {
    boxShadow: 'none',
    background: theme.palette.greyBlue,
  },
}));

const CheckboxCheckedIconSpan = styled(CheckboxIconSpan)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&:before': {
    border: 0,
    content: '""',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundImage: `url("data:image/svg+xml,${checkBoxIconUri}")`,
  },
  'input:disabled ~ &:before': {
    backgroundImage: `url("data:image/svg+xml,${checkBoxDisabledIconUri}")`,
  },
}));

const labelSx = {
  lineHeight: '19px',
};

const StyledCheckbox = props => (
  <Checkbox
    sx={{
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }}
    color="primary"
    icon={<CheckboxIconSpan />}
    checkedIcon={<CheckboxCheckedIconSpan />}
    {...props}
  />
);

const FormikCheckboxGroup = ({
  field,
  form,
  items,
  itemClassName = null,
  itemSelectedClassName = null,
  ...props
}) => {
  if (props.groupClassName === undefined) props.groupClassName = null;
  const { errors, submitCount, getFieldProps } = form;
  const { name, onChange, onBlur } = field;
  const { value } = getFieldProps(name);
  return (
    <FormControl
      error={!!(errors[name] && submitCount > 0)}
      fullWidth
      component="fieldset"
      {...props}
    >
      {items.map(([key, label]) => (
        <FormControlLabel
          className={classNames({
            [itemClassName]: true,
            [itemSelectedClassName]: value?.includes(key),
          })}
          key={key}
          value={key}
          name={name}
          control={<StyledCheckbox onChange={onChange} onBlur={onBlur} />}
          label={label}
          checked={value?.includes(key)}
          slotProps={{ typography: { sx: labelSx } }}
        />
      ))}
      <FormHelperText>{submitCount > 0 && errors[name]}</FormHelperText>
    </FormControl>
  );
};

FormikCheckboxGroup.propTypes = {
  field: object.isRequired,
  form: object.isRequired,
  groupClassName: string,
  items: array.isRequired,
  itemClassName: string,
  itemSelectedClassName: string,
};

export default FormikCheckboxGroup;
